export class GoldenRecordDBConfig {
  exchange: string;
  recordType: string;
  collection: string;
}
